import { useCallback, useState } from "react";

const TOUR_STORAGE_KEY = "catalog-options-list-tour-completed";

export function useOptionsListTour() {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const startTour = useCallback(() => {
    setRun(true);
    setStepIndex(0);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(TOUR_STORAGE_KEY, "true");
    }
  }, []);

  const handleJoyrideCallback = useCallback(
    (data: {
      status?: string;
      type?: string;
      index?: number;
      action?: string;
    }) => {
      const { status, type, index } = data;
      if (index !== undefined) setStepIndex(index);
      if (
        status === "finished" ||
        status === "skipped" ||
        type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour]
  );

  return {
    run,
    stepIndex,
    startTour,
    stopTour,
    handleJoyrideCallback,
  };
}
